module.exports = __webpack_public_path__ + "static/media/table.ed030bda.png";